import React, { FC } from 'react';

interface Props {
  title: string;
}

const Title: FC<Props> = ({ title }) => {
  return <p className='md:text-5xl text-2xl text-white text-center'>{title}</p>;
};

export default Title;
